<template>
  <div class="finance-trading-card">
    <jr-card :title="title">
      <div class="amount">
        退款
        <p>{{data.refundAmount | toFenThousandsAndFloat}}<span>元</span></p>
      </div>
      <el-row :gutter="20">
        <el-col :span="span">
          <div class="info-card info-card-text" v-if="['WAIT'].includes(data.refundStatus) && !data.payAccountName">待付款，请完成付款并确定出款账户</div>
          <div class="info-card info-card-text" v-else-if="data.refundChannel === 'CASH_PAY'">现金记录，无需确定出款账户</div>
          <div class="info-card" v-else>
            <div class="title">
              <div>{{data.payAccountName || '-'}}</div>
            </div>
            <div style="margin: 8px 0 16px">{{data.payBankName || '-'}}</div>
            <div>{{data.payAccountNumber | formatBank}}</div>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="icon-transfer">
            <icon-svg name="icon-transfer" />
          </div>
        </el-col>
        <el-col :span="span">
          <div class="info-card">
            <div class="title">
              <div>{{data.recAccountName || '-'}}</div>
              <div class="tag" v-if="data.recAccountType">{{data.recAccountTypeDesc}}</div>
            </div>
            <div style="margin: 8px 0 16px">{{data.recBankName || '-'}}</div>
            <div>{{data.recAccountNumber | formatBank}}</div>
          </div>
        </el-col>
      </el-row>
    </jr-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    span: {
      type: Number,
      default: 6,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss">
.info-card-text {
  display: flex;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #C9CCD1;
  line-height: 17px;
  align-items: center;
}
</style>
